module.exports = __webpack_public_path__ + "img/top-banner-xs.01ab4ed8.jpg";